/*
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import { useExtensions } from '@adobe/uix-host-react'
import { RegistrationProps, getRequestOptions } from './utils'

export const MassActionBannerNotification = ({ url }: RegistrationProps) => {
  const { extensions } = useExtensions(() => ({
    updateOn: 'all',
    requires: {
      bannerNotification: ['getMassActions']
    }
  }))

  extensions.map(async ({ apis }) => {
    const bannerNotification = await apis.bannerNotification.getMassActions()
    updateBannerNotification(bannerNotification)
  })

  function updateBannerNotification(registeredBanner: any) {
    const notifications = {
      massActions: registeredBanner
    }

    fetch(url, getRequestOptions('banner', notifications)).then((response) =>
      response.json()
    )
  }
}
